export default "__VITE_ASSET__D4B5Zswq__"